import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

/** GET `Report/ai-fadv-user-wise-client/metadata` — table columns + filter schema. */
export const fetchAIFadvReportMetadata = async (data = {}) => {
  try {
    const response = await GET(REPORT.AI_FADV_USER_WISE_CLIENT_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Report/ai-fadv-user-wise-client/filter` */
export const submitAIFadvReportFilterData = async (data = {}) => {
  try {
    const response = await POST(REPORT.AI_FADV_USER_WISE_CLIENT_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Report/ai-fadv-user-wise-client/clients/filter` — clients for an AI FADV user by status. */
export const submitAIFadvReportClientsFilterData = async (data = {}) => {
  try {
    const response = await POST(REPORT.AI_FADV_USER_WISE_CLIENT_CLIENTS_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
